import { Text } from "@chakra-ui/react";
import { InboxActiveTab } from "../../../types/inbox/enum";
import { HandleTabToggleVisibility } from "..";
import { CheckIcon } from "../../../icons";
import { InboxAccordion, ToggleVisibility } from "../../../types/inbox/type";
import { DropdownMenuItem } from "../../atom/Dropdown/Dropdown";

interface InboxHeaderFilterItemProps<Tab extends InboxActiveTab> {
  title: keyof ToggleVisibility;
  onToggleVisibility: HandleTabToggleVisibility;
  toggleVisibility: InboxAccordion;
  activeTab: Tab;
}

const InboxHeaderFilterMenuItem = <Tab extends InboxActiveTab>({
  title,
  onToggleVisibility,
  toggleVisibility,
  activeTab,
}: InboxHeaderFilterItemProps<Tab>) => {
  return (
    <DropdownMenuItem
      className="box-border flex h-8 w-full cursor-pointer items-center justify-between gap-[6px] bg-inherit px-2 py-0 text-body1 hover:bg-w-8-hover hover:outline-none focus:outline-none data-[highlighted]:bg-w-8-hover data-[highlighted]:outline-none"
      onClick={() => onToggleVisibility(title, activeTab)}
    >
      <Text
        textStyle="body3"
        color={toggleVisibility[activeTab][title] ? "#69E4FF" : "#fff"}
      >{`Show ${title} tasks`}</Text>
      <CheckIcon color={toggleVisibility[activeTab][title] ? "#69E4FF" : "transparent"} />
    </DropdownMenuItem>
  );
};

export default InboxHeaderFilterMenuItem;
